import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DocumentService } from 'src/app/core/services/document.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/core/services/common.service';
import { Message } from 'src/app/core/class/message';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { NotificationService } from 'src/app/core/services/notification.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';

@Component({
  selector: 'app-warning-cancel-sign-confirmation',
  templateUrl: './warning-cancel-sign-confirmation.component.html',
  styles: [`
    .info-branch {
      font-family: Roboto, "Helvetica Neue", sans-serif;
    }
  `]
})
export class WarningCancelSignConfirmationComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<WarningCancelSignConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private documentService: DocumentService,
    private toastr: ToastrService,
    public commonService: CommonService,
    public message: Message,
    public notificationService: NotificationService,
    private dialog: MatDialog,
    private contractService: ContractService,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  msg: string = '';
  document = {
    reason: ''
  };
  formChangesSubscription: Subscription;
  initialInfo: any;
  @ViewChild('f', { static: false }) ngForm: NgForm;

  private isFormChanging: any;

  ngOnInit() {
    this.notificationService.subscribeErrorService();
    this.getContractUserApprove();
  }

  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });

    // Focus on textarea reason after load
    // There's a problem if not setTimeout it will focus on 'reason' then lost focus right after
    setTimeout(_ => document.getElementById('reason').focus(), 500);
  }

  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close(false);
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close(false);
    }
  }

  getContractUserApprove() {
    this.initialInfo = this.data.contractUserApprove[0];
    this.generateMsg();
  }

  generateMsg() {
    this.msg = this.commonService.format(
      this.message.getMessage('cancel_sign_confirm.message_confirm'),
      this.data.document.code ? `${this.data.document.code} - ${this.data.document.name}` : this.data.document.name,
      this.initialInfo.name
    )
  }

  declineSignDocument() {
    const data = {
      contractId: this.data.contractId,
      userInitial: {
        ...this.initialInfo,
        userId: this.initialInfo.id
      }, // người trình ký cũ
      reason: this.document.reason // Lý do trình ký lại
    };
    this.contractService.cancelUserSignatureProcess(data).subscribe(result => {
      if (!result.success) {
        this.toastr.error(result.message);
      } else {
        this.toastr.success(this.message.getMessage('messages.cancel_signature_process_success'));
        this.dialogRef.close(true);
      }
    }, error => {
      this.toastr.error(this.message.getMessage('messages.cancel_signature_process_fail'));
    });
  }

}
